import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link, Redirect } from 'react-router-dom';
import Select from '../../components/Select';
import styled from 'styled-components';
import { cxSetTenant } from '../../utils/cxSdk';
import { isInIframe } from 'serenova-js-utils/browser';
import { SettingIconSVG,QuestionMarkCircleIconSVG, CloseIconSVG,DirectionIconSVG} from 'cx-ui-components';
import { CONFIRM_SET_ENTITY_WHEN_FORM_IS_DIRTY } from '../ConfirmationDialog/constants';
import { FormattedMessage } from 'react-intl';
import messages from '../Login/messages';
import { Iterable } from 'immutable';
const NavBar = styled.div`
  background: #00487e;
  ${(props) => props.theme.navbar && `background: ${props.theme.navbar};`} height: 50px;
`;

const SelectorImg = styled.img`
  margin-left: 15px;
  display: inline-block;
  position: relative;
  vertical-align: middle;
  top: 1px;
`;

const SelectorContainer = styled.div`
  margin-left: 10px;
  display: inline-block;
  position: relative;
  vertical-align: middle;
  top: 1px;
`;

const Divider = styled.div`
  display: inline-block;
  position: relative;
  top: 10px;
  width: 2px;
  height: 30px;
  background-color: #ccc;
  margin-left: 30px;
`;

const NavbarMenu = styled.div`
  color: #ccc;
  ${(props) => props.theme.navbarText && `color: ${props.theme.navbarText};`} display: inline-block;
  margin-left: 30px;
  cursor: pointer;
  font-size: 12pt;
`;

const Settings = styled.div`
  display: inline-block;
  float: right;
  padding: 14px;
  cursor: pointer;
`;

const Help = styled.div`
  display: inline-block;
  float: right;
  padding: 14px;
  cursor: pointer;
`;

const Privacy = styled.a`
   display: inline-block;
   float: right;
   padding: 14px 10px;
   text-decoration:none;
    font-weight: 150;
    height: 50px;
    position: relative;
    display: inline-block;
    cursor: pointer;
    font-size: 12pt;
    color: ${props => props.theme.navbarText ? props.theme.navbarText : '#ffffff'};
`;

const SubMenu = styled.div`
  background-color: #ffffff;
  border: 1px solid #cccccc;
  border-top: none;
  font-weight: normal;
  overflow-y: auto;
  position: absolute;
  padding: 6px 0;
  min-width: 200px;
  z-index: 1;
  ${(props) => props.right && `right: ${props.right}`};
  ${(props) => props.left && `left: ${props.left}`};
`;

const StyledLink = styled(Link)`
  font-family: Arial, Helvetica, sans-serif;
  font-size: 14px;
  border-left: 5px solid #fff;
  color: #656565;
  display: block;
  background: #ffffff;
  padding: 13px 6px 10px 10px;
  text-decoration: none;
  &:hover {
    background:  ${props => props.theme.accentHoverColor ? props.theme.accentHoverColor : '#656565'};
    border-left:   ${props => props.theme.accentColor ? "10px solid " + props.theme.accentColor : '10px solid #656565'};
}
`;

const StyledButtonLink = styled.button`
  font-family: Arial, Helvetica, sans-serif;
  font-size: 14px;
  border:0px;
  border-left: 5px solid #fff;
  color: #656565;
  display: block;
  background: #ffffff;
  padding: 13px 6px 10px 10px;
  text-decoration: none;
  text-align: start;
  &:hover {
    background:  ${props => props.theme.accentHoverColor ? props.theme.accentHoverColor : '#656565'};
    border-left:   ${props => props.theme.accentColor ? "10px solid " + props.theme.accentColor : '10px solid #656565'};
}`;

const StyledLinkAnchor = styled.a`
  font-family: Arial, Helvetica, sans-serif;
  font-size: 14px;
  border-left: 5px solid #fff;
  color: #656565;
  display: block;
  background: #ffffff;
  padding: 10px 6px 10px 5px;
  text-decoration: none;
`;

const Welcome = styled.div`
  font-family: Arial, Helvetica, sans-serif;
  font-size: 14px;
  border-left: 5px solid #fff;
  color: #656565;
  display: block;
  background: #ffffff;
  padding: 10px 6px 10px 5px;
`;

const ProSchedulerPopWrapper = styled.div`
  position: absolute;
  justify-content: center;
  z-index: 9;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  bottom: 0;
  width: 100%;
  right: 0;
`;

const ProSchedulerPop = styled.div`
  border: 1px solid #dadada;
  width: 450px;
  height: 150px;
  text-align: center;
  padding: 15px;
  position: absolute;
  background-color: #fff;
  box-shadow: -1px 0px 17px -3px rgb(0 0 0 / 50%);
  z-index: 9;
`;

const CloseButtonWrapper = styled.div`
  position: absolute;
  display: block;
  text-align: right;
  right: 15px;
`;

const ProSchedulerPopMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex-direction: column;
  height: 100%;
`;

const ProSchedulerPopHead = styled.div`
  font-weight: 700;
`;

const StyleLinkDiv = styled.div`
  display:flex;
`;

const StyleLinkIconDiv = styled.div`
  max-width: 30px;
  text-align: center;
  flex:1;
`;

const AnchorTag = styled.a`
&:hover {
  background-color: transparent;
}
`;

const styles = {
  selectTenantDropdown: {
    width: '200px',
    height: '40px',
    backgroundColor: 'none',
    color: '#ccc',
    border: '1px solid #ccc',
    borderRadius: '5px',
    padding: '0px 10px',
  },
};

const getThemeColor = (props) => {
  return props.theme.navbarText ? props.theme.navbarText : "#FFF"
}

export default class Navigation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visibleMenu: 'none',
      isWfmPopVisible: false,
    };
  }

  componentDidMount = (props) => {
    let linkCollection = document.getElementsByTagName("link");
    let linkList = Array.from(linkCollection)
    var FavLink = linkList.find(item => item.rel = "shortcut icon");
    if (FavLink) {
      FavLink.href = this.props.favicon;
    }
  }

  setSelectedTenant = (tenantId, requiresReAuth) => {
    if (tenantId !== this.props.currentTenantId) {
      if (!requiresReAuth) {
        cxSetTenant(tenantId, (response) => {
          this.props.switchTenant(response.tenantId);
          this.props.fetchBranding();
        });
        localStorage.setItem('tenant', tenantId);
      } else {
        const selectingTenant = this.props.tenants.find((tenant) => tenant.tenantId === tenantId);
        if (selectingTenant) {
          if (selectingTenant.password && selectingTenant.identityProviders.length === 0) {
            localStorage.setItem('loginPreferences', JSON.stringify({ sso: false }));
            localStorage.removeItem('LIVEOPS-PREFERENCE-KEY');
            this.props.setUserAuthed(false);
            this.props.switchTenant('');
            CxEngage.session.setToken();
            <Redirect to="/" />;
            window.location.reload();
            // return;
          } else {
            localStorage.setItem('loginPreferences', JSON.stringify({ sso: true }));
            window.history.pushState(
              '',
              document.title,
              `${window.location.pathname}${window.location.search ? `${window.location.search}&` : '?'}tenantid=${selectingTenant.tenantId
              }${window.location.hash}`
            );
            window.location.reload();
            // return;
          }
        }
      }
    }
  };

  setVisibleMenu = (menuName) =>
    this.setState(({ visibleMenu }) => ({
      visibleMenu: visibleMenu === menuName ? 'none' : menuName,
    }));

  setCurrentEntityAndEntityId = (entityName, e) => {
    if (this.props.isCurrentFormDirty || this.props.areSubEntityFormsDirty) {
      e.preventDefault();
      this.props.setConfirmationDialog(CONFIRM_SET_ENTITY_WHEN_FORM_IS_DIRTY, '', entityName);
    } else {
      this.props.setSelectedEntityId('');
      this.props.setCurrentEntity(entityName);
    }
  };


  logout = (e) => {
    var monitoredInteraction=null;
    if (CxEngage.session.getMonitoredVoiceInteraction()) {
      monitoredInteraction = CxEngage.session.getMonitoredVoiceInteraction();
    }
    if (monitoredInteraction !== null) {
      let confirmedToLogout = confirm('Are you sure you want to logout?');
      if (confirmedToLogout) {
        CxEngage.interactions.voice.resourceRemove({ interactionId: monitoredInteraction }, function () {
          setTimeout(function () {
            // Removing from current session key used for logi reports,
            // this will be removed automatically also if browser tab is closed
            sessionStorage.removeItem('LOGI-USER-IMPERSONATE');
            sessionStorage.clear();
            localStorage.clear();
            // Reload ensure no saved state for the next session
            location.reload(true);
          }, 1000);
        });
      }
    } else {
      // Removing from current session key used for logi reports,
      // this will be removed automatically also if browser tab is closed
      sessionStorage.removeItem('LOGI-USER-IMPERSONATE');
      localStorage.clear();
      sessionStorage.clear();
      location.reload(true);
    }
  }

  setWfmPopup = (val) => {
    this.setState({ isWfmPopVisible: val });
  };

  render() {
    const inLoginPage = window.location.hash === '#/' || window.location.hash.includes('index.html');
    let options = this.props.tenantsList;
    if (options && Iterable.isIterable(options)) {
      options = options.toJS();
    }
    const showNavBar = isInIframe() && !inLoginPage;
    return (
      showNavBar && (
        <NavBar theme={this.props.theme}>
          <AnchorTag href="#/">
            {this.props.logo && <SelectorImg src={this.props.logo} height="23"></SelectorImg>}
          </AnchorTag>
          <SelectorContainer>
            <Select
              id="switchTenant"
              style={styles.selectTenantDropdown}
              value={this.props.currentTenantId}
              onChange={(e) => this.setSelectedTenant(e.value || '-1', e.requiresReAuth || false)}
              options={ options }
              noSuggestionsMessage="No Options"
              clearable={false}
              placeholder={<FormattedMessage {...messages.selectTenantMenu} />}
            />
          </SelectorContainer>

          <Divider />

          {this.props.menuPermissions.userMenu && 
          <NavbarMenu
            theme={this.props.theme}
            data-automation="userManagementMenu"
            onClick={() => this.setVisibleMenu('User Management')}>
            <FormattedMessage id="navigation.management" defaultMessage="User Management" />
            {this.state.visibleMenu === 'User Management' && (
              <SubMenu>
                {this.props.menuPermissions.users &&
                <StyledLink
                  theme={this.props.theme}
                  data-automation="navigationLinkUsers"
                  to="/configuration/users"
                  onClick={(e) => this.setCurrentEntityAndEntityId('users', e)}>
                  <FormattedMessage id="navigation.management.users" defaultMessage="Users" />
                </StyledLink>
                }
                {this.props.menuPermissions.groups &&
                  <StyledLink
                    theme={this.props.theme}
                    data-automation="navigationLinkGroups"
                    to="/configuration/groups"
                    onClick={(e) => this.setCurrentEntityAndEntityId('groups', e)}>
                    <FormattedMessage id="navigation.management.groups" defaultMessage="Groups" />
                  </StyledLink>
                }
                {this.props.menuPermissions.skills &&
                  <StyledLink
                    theme={this.props.theme}
                    data-automation="navigationLinkSkills"
                    to="/configuration/skills"
                    onClick={(e) => this.setCurrentEntityAndEntityId('skills', e)}>
                    <FormattedMessage id="navigation.management.skills" defaultMessage="Skills" />
                  </StyledLink>
                }
                {this.props.menuPermissions.roles &&
                  <StyledLink
                  theme={this.props.theme}
                    data-automation="navigationLinkRoles"
                    to="/configuration/roles"
                    onClick={(e) => this.setCurrentEntityAndEntityId('roles', e)}>
                    <FormattedMessage id="navigation.management.roles" defaultMessage="Roles" />
                  </StyledLink>
                }
                {this.props.menuPermissions.reasons &&
                  <StyledLink
                  theme={this.props.theme}
                    data-automation="navigationLinkReasons"
                    to="/configuration/reasons"
                    onClick={(e) => this.setCurrentEntityAndEntityId('reasons', e)}>
                    <FormattedMessage id="navigation.management.reasons" defaultMessage="Presence Reasons" />
                  </StyledLink>
                }
                {this.props.menuPermissions.reasonLists &&
                  <StyledLink
                  theme={this.props.theme}
                    data-automation="navigationLinkReasonLists"
                    to="/configuration/reasonLists"
                    onClick={(e) => this.setCurrentEntityAndEntityId('reasonLists', e)}>
                    <FormattedMessage id="navigation.management.reasonsList" defaultMessage="Presence Reason Lists" />
                  </StyledLink>
                }
                {this.props.menuPermissions.capacityRules &&
                  <StyledLink
                  theme={this.props.theme}
                    data-automation="navigationLinkCapacityRule"
                    to="/configuration/capacityRules"
                    onClick={(e) => this.setCurrentEntityAndEntityId('capacityRules', e)}>
                    <FormattedMessage id="navigation.management.capacityRules" defaultMessage="Capacity Rules" />
                  </StyledLink>
                }
              </SubMenu>
            )}
          </NavbarMenu>
  }

{this.props.menuPermissions.configurationMenu && 
          <NavbarMenu
            theme={this.props.theme}
            data-automation="configurationMenu"
            onClick={() => this.setVisibleMenu('Configuration')}>
            <FormattedMessage id="navigation.configuration" defaultMessage="Configuration" />
            {this.state.visibleMenu === 'Configuration' && (
              <SubMenu>
                {this.props.menuPermissions.tenants &&
                <StyledLink
                  theme={this.props.theme}
                  data-automation="navigationLinkTenants"
                  to="/configuration/tenants"
                  onClick={(e) => this.setCurrentEntityAndEntityId('tenants', e)}>
                  <FormattedMessage id="navigation.configuration.tenants" defaultMessage="Tenants" />
                </StyledLink>
                }
                {this.props.menuPermissions.identityProviders &&
                <StyledLink
                  theme={this.props.theme}
                  data-automation="navigationLinkIdentityProviders"
                  to="/configuration/identityProviders"
                  onClick={(e) => this.setCurrentEntityAndEntityId('identityProviders', e)}>
                  <FormattedMessage
                    id="navigation.configuration.identityProviders"
                    defaultMessage="Identity Providers"
                  />
                </StyledLink>
                }
                {this.props.menuPermissions.integrations &&
                <StyledLink
                  theme={this.props.theme}
                  data-automation="navigationLinkIntegrations"
                  to="/configuration/integrations"
                  onClick={(e) => this.setCurrentEntityAndEntityId('integrations', e)}>
                  <FormattedMessage id="navigation.configuration.integrations" defaultMessage="Integrations" />
                </StyledLink>
                }{this.props.menuPermissions.lists &&
                <StyledLink
                  theme={this.props.theme}
                  data-automation="navigationLinkLists"
                  to="/configuration/lists"
                  onClick={(e) => this.setCurrentEntityAndEntityId('lists', e)}>
                  <FormattedMessage id="navigation.configuration.lists" defaultMessage="Lists" />
                </StyledLink>
                }{this.props.menuPermissions.slas &&
                <StyledLink
                  theme={this.props.theme}
                  data-automation="navigationLinkSlas"
                  to="/configuration/slas"
                  onClick={(e) => this.setCurrentEntityAndEntityId('slas', e)}>
                  <FormattedMessage id="navigation.configuration.slas" defaultMessage="Statistics" />
                </StyledLink>
                }{this.props.menuPermissions.emailTemplates &&
                <StyledLink
                  theme={this.props.theme}
                  data-automation="navigationLinkEmailTemplates"
                  to="/configuration/emailTemplates"
                  onClick={(e) => this.setCurrentEntityAndEntityId('emailTemplates', e)}>
                  <FormattedMessage
                    id="navigation.configuration.emailTemplates"
                    defaultMessage="User Management Emails"
                  />
                </StyledLink>
                }{this.props.menuPermissions.outboundIdentifiers &&
                <StyledLink
                  theme={this.props.theme}
                  data-automation="navigationLinkOutboundIdentifiers"
                  to="/configuration/outboundIdentifiers"
                  onClick={(e) => this.setCurrentEntityAndEntityId('outboundIdentifiers', e)}>
                  <FormattedMessage
                    id="navigation.configuration.outboundIdentifiers"
                    defaultMessage="Outbound Identifiers"
                  />
                </StyledLink>
                }{this.props.menuPermissions.outboundIdentifierLists &&
                <StyledLink
                  theme={this.props.theme}
                  data-automation="navigationLinkOutboundIdentifierLists"
                  to="/configuration/outboundIdentifierLists"
                  onClick={(e) => this.setCurrentEntityAndEntityId('outboundIdentifierLists', e)}>
                  <FormattedMessage
                    id="navigation.configuration.outboundIdentifierLists"
                    defaultMessage="Outbound Identifier Lists"
                  />
                </StyledLink>
                }{this.props.menuPermissions.chatWidgets &&
                <StyledLink
                  theme={this.props.theme}
                  data-automation="navigationLinkChatWidgets"
                  to="/configuration/chatWidgets"
                  onClick={(e) => this.setCurrentEntityAndEntityId('chatWidgets', e)}>
                  <FormattedMessage id="navigation.configuration.chatWidgets" defaultMessage="Chat Widgets" />
                </StyledLink>
                }{this.props.menuPermissions.whatsappIntegrations &&
                <StyledLink
                  theme={this.props.theme}
                  data-automation="navigationLinkWhatsappIntegrations"
                  to="/configuration/whatsappIntegrations"
                  onClick={(e) => this.setCurrentEntityAndEntityId('whatsappIntegrations', e)}>
                  <FormattedMessage
                    id="navigation.configuration.whatsappIntegrations"
                    defaultMessage="Whatsapp Integrations"
                  />
                </StyledLink>
                }{this.props.menuPermissions.facebookIntegrations &&
                <StyledLink
                  theme={this.props.theme}
                  data-automation="navigationLinkFacebookIntegrations"
                  to="/configuration/facebookIntegrations"
                  onClick={(e) => this.setCurrentEntityAndEntityId('facebookIntegrations', e)}>
                  <FormattedMessage id="navigation.configuration.facebookIntegrations" defaultMessage="Facebook" />
                </StyledLink>
                }{this.props.menuPermissions.transferLists &&
                <StyledLink
                  theme={this.props.theme}
                  data-automation="navigationLinkTransferLists"
                  to="/configuration/transferLists"
                  onClick={(e) => this.setCurrentEntityAndEntityId('transferLists', e)}>
                  <FormattedMessage id="navigation.configuration.transferLists" defaultMessage="Transfer Lists" />
                </StyledLink>
                }{this.props.menuPermissions.apiKeys &&
                <StyledLink
                  theme={this.props.theme}
                  data-automation="navigationLinkApiKeys"
                  to="/configuration/apiKeys"
                  onClick={(e) => this.setCurrentEntityAndEntityId('apiKeys', e)}>
                  <FormattedMessage id="navigation.configuration.apiKeys" defaultMessage="API Key Management" />
                </StyledLink>
                }{this.props.menuPermissions.messageTemplates &&
                <StyledLink
                  theme={this.props.theme}
                  data-automation="navigationLinkMessageTemplates"
                  to="/configuration/messageTemplates"
                  onClick={(e) => this.setCurrentEntityAndEntityId('messageTemplates', e)}>
                  <FormattedMessage id="navigation.configuration.messageTemplates" defaultMessage="Message Templates" />
                </StyledLink>
                }{this.props.menuPermissions.businessHours && //businessHoursV2
                <StyledLink
                  theme={this.props.theme}
                  data-automation="navigationLinkBusinessHours"
                  to="/configuration/businessHoursV2"
                  onClick={(e) => this.setCurrentEntityAndEntityId('businessHours', e)}>
                  <FormattedMessage id="navigation.configuration.businessHours" defaultMessage="Business Hours" />
                </StyledLink>
                }{this.props.menuPermissions.contactAttributes &&
                <StyledLink
                  theme={this.props.theme}
                  data-automation="navigationLinkContactAttributes"
                  to="/configuration/contactAttributes"
                  onClick={(e) => this.setCurrentEntityAndEntityId('contactAttributes', e)}>
                  <FormattedMessage
                    id="navigation.configuration.contactAttributes"
                    defaultMessage="Contact Attributes"
                  />
                </StyledLink>
                }{this.props.menuPermissions.contactLayouts &&
                <StyledLink
                  theme={this.props.theme}
                  data-automation="navigationLinkContactLayouts"
                  to="/configuration/contactLayouts"
                  onClick={(e) => this.setCurrentEntityAndEntityId('contactLayouts', e)}>
                  <FormattedMessage id="navigation.configuration.contactLayouts" defaultMessage="Contact Layouts" />
                </StyledLink>
                }{this.props.menuPermissions.alps &&
                <StyledLink
                  theme={this.props.theme}
                  data-automation="navigationLinkAlps"
                  to="/configuration/alps"
                  onClick={(e) => this.setCurrentEntityAndEntityId('alps', e)}>
                  <FormattedMessage id="navigation.configuration.alps" defaultMessage="Artifacts Lifecycle Policy" />
                </StyledLink>
                }{this.props.menuPermissions.amr &&
                 <StyledLink
                  theme={this.props.theme}
                  data-automation="navigationLinkAmr"
                  to="/configuration/amr"
                  onClick={(e) =>this.setCurrentEntityAndEntityId('amr', e)}>
                  <FormattedMessage id="navigation.configuration.amr" defaultMessage="Artifacts Management Requests" />
                </StyledLink>
                }
              </SubMenu>
            )}
          </NavbarMenu>
  }
{this.props.menuPermissions.flowMenu && 
          <NavbarMenu theme={this.props.theme} data-automation="flowsMenu" onClick={() => this.setVisibleMenu('Flows')}>
            <FormattedMessage id="navigation.flows" defaultMessage="Flows" />
            {this.state.visibleMenu === 'Flows' && (
              <SubMenu>
                {this.props.menuPermissions.flows &&
                <StyledLink
                  theme={this.props.theme}
                  data-automation="navigationLinkFlows"
                  to="/configuration/flows"
                  onClick={(e) => this.setCurrentEntityAndEntityId('flows', e)}>
                  <FormattedMessage id="navigation.flows" defaultMessage="Flows" />
                </StyledLink>
                }{this.props.menuPermissions.dispositions &&
                <StyledLink
                  theme={this.props.theme}
                  data-automation="navigationLinkDispositions"
                  to="/configuration/dispositions"
                  onClick={(e) => this.setCurrentEntityAndEntityId('dispositions', e)}>
                  <FormattedMessage id="navigation.flows.dispositions" defaultMessage="Dispositions" />
                </StyledLink>
                }{this.props.menuPermissions.dispositionLists &&
                <StyledLink
                  theme={this.props.theme}
                  data-automation="navigationLinkDispositionLists"
                  to="/configuration/dispositionLists"
                  onClick={(e) => this.setCurrentEntityAndEntityId('dispositionLists', e)}>
                  <FormattedMessage id="navigation.flows.dispositionLists" defaultMessage="Disposition Lists" />
                </StyledLink>
                }
                {this.props.menuPermissions.queues &&
                <StyledLink
                theme={this.props.theme}
                  data-automation="navigationLinkQueues"
                  to="/configuration/queues"
                  onClick={(e) => this.setCurrentEntityAndEntityId('queues', e)}>
                  <FormattedMessage id="navigation.flows.queues" defaultMessage="Queues" />
                </StyledLink>
                }{this.props.menuPermissions.media &&
                <StyledLink
                theme={this.props.theme}
                  data-automation="navigationLinkMedia"
                  to="/configuration/media"
                  onClick={(e) => this.setCurrentEntityAndEntityId('media', e)}>
                  <FormattedMessage id="navigation.flows.media" defaultMessage="Media" />
                </StyledLink>
                }{this.props.menuPermissions.flowDebugger &&
                <StyledLink
                theme={this.props.theme}
                  data-automation="navigationLinkFlowDebugger"
                  to="/flowDebugLogs"
                  onClick={(e) => this.setCurrentEntityAndEntityId('flowDebugLogs', e)}>
                  <FormattedMessage id="navigation.flows.flowDebugLogs" defaultMessage="Flow Debug Logs" />
                </StyledLink>
                }{this.props.menuPermissions.dispatchMappings &&
                <StyledLink
                theme={this.props.theme}
                  data-automation="navigationLinkDispatchMappings"
                  to="/configuration/dispatchMappings"
                  onClick={(e) => this.setCurrentEntityAndEntityId('dispatchMappings', e)}>
                  <FormattedMessage id="navigation.flows.dispatchmappings" defaultMessage="Dispatch Mappings" />
                </StyledLink>
                }{this.props.menuPermissions.customAttributes &&
                <StyledLink
                theme={this.props.theme}
                  data-automation="navigationLinkCustomAttributes"
                  to="/configuration/customAttributes"
                  onClick={(e) => this.setCurrentEntityAndEntityId('customAttributes', e)}>
                  <FormattedMessage id="navigation.flows.customAttributes" defaultMessage="Custom Attributes" />
                </StyledLink>
                }
              </SubMenu>
            )}
          </NavbarMenu>}
{this.props.menuPermissions.reportingMenu && 
          <NavbarMenu
            theme={this.props.theme}
            data-automation="reportingMenu"
            onClick={() => this.setVisibleMenu('Reporting')}>
            <FormattedMessage id="navigation.reports" defaultMessage="Reporting" />
            {this.state.visibleMenu === 'Reporting' && (
              <SubMenu>
                {/* temporary hiding this menu until is fixed - fake data for now */}
                {/*<StyledLink*/}
                {/*  data-automation="navigationLinkForecastDashboards"*/}
                {/*  to="/forecastDashboards"*/}
                {/*  onClick={(e) => this.setCurrentEntityAndEntityId('forecastDashboards', e)}>*/}
                {/*  <FormattedMessage id="navigation.reports.forecastDashboards" defaultMessage="Forecast Dashboards" />*/}
                {/*</StyledLink>*/}
                {this.props.menuPermissions.dataAccessReports &&
                <StyledLink
                theme={this.props.theme}
                  data-automation="navigationLinkDataAccessReports"
                  to="/configuration/dataAccessReports"
                  onClick={(e) => this.setCurrentEntityAndEntityId('dataAccessReports', e)}>
                  <FormattedMessage
                    id="navigation.configuration.dataAccessReports"
                    defaultMessage="Access Controlled Reports"
                  />
                </StyledLink>
                }{this.props.menuPermissions.interactionManagement &&
                <StyledLink
                theme={this.props.theme}
                  data-automation="navigationLinkInteractionManagement"
                  to="/interactionManagement"
                  onClick={(e) => this.setCurrentEntityAndEntityId('interactionManagement', e)}>
                  <FormattedMessage
                    id="navigation.reports.interactionManagement"
                    defaultMessage="Interaction Management"
                  />
                </StyledLink>
                }{this.props.menuPermissions.interactionMonitoring &&
                <StyledLink
                theme={this.props.theme}
                  data-automation="navigationLinkInteractionMonitoring"
                  to="/interactionMonitoring"
                  onClick={(e) => this.setCurrentEntityAndEntityId('interactionMonitoring', e)}>
                  <FormattedMessage
                    id="navigation.reports.interactionMonitoring"
                    defaultMessage="Interaction Monitoring"
                  />
                </StyledLink>
                }{this.props.menuPermissions.agentStateMonitoring &&
                <StyledLink
                theme={this.props.theme}
                  data-automation="navigationLinkAgentStateMonitoring"
                  to="/agentStateMonitoring"
                  onClick={(e) => this.setCurrentEntityAndEntityId('agentStateMonitoring', e)}>
                  <FormattedMessage
                    id="navigation.reports.agentStateMonitoring"
                    defaultMessage="Agent State Monitoring"
                  />
                </StyledLink>
                }
              </SubMenu>
            )}
          </NavbarMenu>
  }
          {this.props.userHasWFMPermissions && (
            <NavbarMenu theme={this.props.theme} data-automation="wfmMenu" onClick={() => this.setVisibleMenu('WFM')}>
              <FormattedMessage id="navigation.wfm" defaultMessage="WFM" />
              {this.state.visibleMenu === 'WFM' && (
                <SubMenu>
                  <StyledLinkAnchor href="Lifesizecxwfm://" onClick={() => this.setWfmPopup(true)}>
                    <FormattedMessage id="navigation.wfm.cxwfm" defaultMessage="CxWFM" />
                  </StyledLinkAnchor>
                  <StyledLinkAnchor href={this.props.wfmPlayBookUrl} target="_blank">
                    <FormattedMessage id="navigation.wfm.playbook" defaultMessage="Playbook" />
                  </StyledLinkAnchor>
                  <StyledLinkAnchor href={this.props.wfmUrl} target="_blank">
                    <FormattedMessage id="navigation.wfm.cxwfmweb" defaultMessage="CxWFM Web" />
                  </StyledLinkAnchor>
                </SubMenu>
              )}
            </NavbarMenu>
          )}

          <Privacy theme={this.props.theme} target="_blank" href="https://www.lifesize.com/en/legal-notices/cxengage-privacy-policy/">Privacy</Privacy>

          <Help data-automation="helpMenu" onClick={() => this.setVisibleMenu('Help')}>
            <QuestionMarkCircleIconSVG size={20} color={getThemeColor(this.props)} hoverColor="#CCC" questionmarkcircleIconType="secondary" />
            {this.state.visibleMenu === 'Help' && (
              <SubMenu right="0.5%"  style={{display:'flex',flexDirection:'column'}}>
                <StyledButtonLink
                  theme={this.props.theme}
                  data-automation="navigationHelp"
                  onClick={(e) => {
                    var url = 'https://docs.cxengage.net/Help/Content/Home.htm';
                    window.open(url);
                  }}>
                  <FormattedMessage id="navigation.help" defaultMessage="Help" />
                </StyledButtonLink>
                <StyledButtonLink
                  theme={this.props.theme}
                  data-automation="navigationLAPIDocumentationLink"
                  onClick={(e) => {
                    var url = 'https://api-docs.cxengage.net/Rest/Default.htm';
                    window.open(url);
                  }}>
                  <FormattedMessage id="navigation.APIDocumentationLink" defaultMessage="API Documentation" />
                </StyledButtonLink>
              </SubMenu>
            )}
          </Help>

          <Settings data-automation="settingsMenu" onClick={() => this.setVisibleMenu('Settings')}>
            <SettingIconSVG size={20} color={getThemeColor(this.props)} hoverColor="#CCC" />
            {this.state.visibleMenu === 'Settings' && (
              <SubMenu right="0.5%">
                <Welcome>
                  <FormattedMessage
                    id="navigation.welcome"
                    values={{
                      displayName: this.props.currentUserName,
                    }}
                    defaultMessage="Welcome, {displayName}"
                  />
                </Welcome>
                <StyledLink
                  data-automation="navigationLinkLogout"
                  to={window.location.hostname}
                  onClick={(e) => this.logout(e)}>
                     <StyleLinkDiv>
                    <StyleLinkIconDiv>
                      <DirectionIconSVG size={15} color="#CCC" settingIconType="secondary" />
                    </StyleLinkIconDiv>
                  <FormattedMessage id="navigation.logout" defaultMessage="Logout" />
                  </StyleLinkDiv>
                </StyledLink>
                {this.props.menuPermissions.userProfile &&
                <StyledLink
                  data-automation="navigationLinkUserProfile"
                  to="/userProfile"
                  onClick={(e) => this.setCurrentEntityAndEntityId('userProfile', e)}>
                  <StyleLinkDiv>
                    <StyleLinkIconDiv>
                      <SettingIconSVG size={15} color="#CCC" settingIconType="secondary" />
                    </StyleLinkIconDiv>
                    <FormattedMessage id="navigation.profile" defaultMessage="User Profile" />
                  </StyleLinkDiv>
                </StyledLink>
                }
              </SubMenu>
            )}
          </Settings>
          {this.state.isWfmPopVisible && (
            <ProSchedulerPopWrapper>
              <ProSchedulerPop>
                <CloseButtonWrapper>
                  <CloseIconSVG onClick={() => this.setWfmPopup(false)} size={18} closeIconType="secondary" />
                </CloseButtonWrapper>
                <ProSchedulerPopMessage>
                  <ProSchedulerPopHead>Application is launching...</ProSchedulerPopHead>
                  <br />If application does not launch, please download and install the application.
                </ProSchedulerPopMessage>
              </ProSchedulerPop>
            </ProSchedulerPopWrapper>
          )}
        </NavBar>
      )
    );
  }
}

Navigation.propTypes = {
  accountTenants: PropTypes.any,
  areSubEntityFormsDirty: PropTypes.bool,
  authenticatedAndBrandingReady: PropTypes.bool.isRequired,
  currentTenantId: PropTypes.string.isRequired,
  currentTenantName: PropTypes.string.isRequired,
  currentUserName: PropTypes.string,
  fetchBranding: PropTypes.func.isRequired,
  isCurrentFormDirty: PropTypes.bool,
  setConfirmationDialog: PropTypes.func,
  setCurrentEntity: PropTypes.func.isRequired,
  setSelectedEntityId: PropTypes.func.isRequired,
  setUserAuthed: PropTypes.func.isRequired,
  switchTenant: PropTypes.func.isRequired,
  tenants: PropTypes.any,
  tenantsList: PropTypes.any,
  theme: PropTypes.object,
  userHasWFMPermissions: PropTypes.bool,
  wfmPlayBookUrl: PropTypes.string,
  wfmUrl: PropTypes.string,
};
